export default __webpack_public_path__ + "static/media/img1.aaa807c0.png";